'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: auto;\n'], ['\n  width: auto;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: ', ';\n  z-index: 100;\n'], ['\n  margin: ', ';\n  z-index: 100;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border: ', ' #eee solid;\n  border-radius: ', ';\n  box-shadow: ', ';\n  position: absolute;\n  width: auto;\n  max-width: ', ';\n  z-index: 100;\n  background-color: rgb(248, 248, 248);\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgb(166, 166, 166);\n  border-image: initial;\n'], ['\n  border: ', ' #eee solid;\n  border-radius: ', ';\n  box-shadow: ', ';\n  position: absolute;\n  width: auto;\n  max-width: ', ';\n  z-index: 100;\n  background-color: rgb(248, 248, 248);\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgb(166, 166, 166);\n  border-image: initial;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  z-index: 10;\n'], ['\n  z-index: 10;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _uniqid = require('uniqid');

var _uniqid2 = _interopRequireDefault(_uniqid);

var _LabeledCheckbox = require('../LabeledCheckbox');

var _LabeledCheckbox2 = _interopRequireDefault(_LabeledCheckbox);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents2.default.div(_templateObject);

var Item = _styledComponents2.default.div(_templateObject2, (0, _polished.rem)(10));

var ItemsWrapper = _styledComponents2.default.div(_templateObject3, (0, _polished.rem)(1), (0, _polished.rem)(4), function (_ref) {
  var theme = _ref.theme;
  return theme.shadow;
}, (0, _polished.rem)(300));

var StyledInput = (0, _styledComponents2.default)(_Input2.default)(_templateObject4);

var MultiSelect = function (_Component) {
  _inherits(MultiSelect, _Component);

  function MultiSelect(props) {
    _classCallCheck(this, MultiSelect);

    var _this = _possibleConstructorReturn(this, (MultiSelect.__proto__ || Object.getPrototypeOf(MultiSelect)).call(this, props));

    _this.state = {
      text: '',
      itemsVisible: false,
      value: [],
      wrapperRef: null
    };
    _this.onClickOutside = _this.onClickOutside.bind(_this);
    return _this;
  }

  _createClass(MultiSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          options = _props.options,
          value = _props.value; // expand option objects with an id field to exclude problems with the same values //

      var optionsWithId = options.map(function (o) {
        var optionWithId = Object.assign({}, o);
        optionWithId.id = (0, _uniqid2.default)();
        return optionWithId;
      }); // work with id instead values

      var checkedOptions = [];
      optionsWithId.forEach(function (o) {
        if (value.indexOf(o.value) > -1) {
          checkedOptions.push(o.id);
        }
      }); // eslint-disable-next-line

      this.setState({
        value: checkedOptions,
        options: optionsWithId,
        visibleOptions: optionsWithId
      });
      document.addEventListener('click', this.onClickOutside);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.options !== prevProps.options) {
        var _props2 = this.props,
            options = _props2.options,
            value = _props2.value; // expand option objects with an id field to exclude problems with the same values

        var optionsWithId = options.map(function (o) {
          var optionWithId = Object.assign({}, o);
          optionWithId.id = (0, _uniqid2.default)();
          return optionWithId;
        }); // work with id instead values

        var checkedOptions = [];
        optionsWithId.forEach(function (o) {
          if (value.indexOf(o.value) > -1) {
            checkedOptions.push(o.id);
          }
        }); // eslint-disable-next-line

        this.setState({
          value: checkedOptions,
          options: optionsWithId,
          visibleOptions: optionsWithId
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onClickOutside);
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside(e) {
      if (this.state.wrapperRef && !this.state.wrapperRef.contains(e.target)) {
        this.setState({
          itemsVisible: false
        });
      }
    }
  }, {
    key: 'onCheckBoxClick',
    value: function onCheckBoxClick(item) {
      var _state = this.state,
          value = _state.value,
          options = _state.options;
      var onChange = this.props.onChange;
      var newValue = void 0;

      if (value.indexOf(item) > -1) {
        newValue = value.filter(function (v) {
          return v !== item;
        });
      } else {
        value.push(item);
        newValue = value;
      }

      var valueForReturn = [];
      options.forEach(function (o) {
        if (newValue.indexOf(o.id) > -1) {
          valueForReturn.push(o.value);
        }
      });
      this.setState({
        value: newValue
      }, function () {
        return onChange(valueForReturn);
      });
    }
  }, {
    key: 'setWrapperRef',
    value: function setWrapperRef(node) {
      this.state.wrapperRef = node;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState({
        text: e.target.value,
        itemsVisible: true
      });
      this.filter(e.target.value);
    }
  }, {
    key: 'filter',
    value: function filter(text) {
      var options = this.state.options;
      var visibleOptions = options.filter(function (v) {
        return v.label.startsWith(text);
      });

      if (text === '') {
        visibleOptions = options;
      }

      this.setState({
        visibleOptions: visibleOptions
      });
    }
  }, {
    key: 'toggleItems',
    value: function toggleItems() {
      if (this.state.itemsVisible) {
        this.setState({
          itemsVisible: false
        });
      } else {
        this.setState({
          itemsVisible: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          className = _props3.className,
          placeholder = _props3.placeholder;
      var _state2 = this.state,
          text = _state2.text,
          itemsVisible = _state2.itemsVisible,
          value = _state2.value,
          visibleOptions = _state2.visibleOptions;
      return _react2.default.createElement(Wrapper, {
        className: className,
        innerRef: function innerRef(node) {
          return _this2.setWrapperRef(node);
        }
      }, _react2.default.createElement(StyledInput, {
        placeholder: value.length === 0 ? placeholder : value.length + ' zvolen\xE9',
        value: text,
        onChange: function onChange(e) {
          return _this2.handleChange(e);
        },
        onClick: function onClick() {
          return _this2.toggleItems();
        }
      }), itemsVisible && _react2.default.createElement(ItemsWrapper, null, visibleOptions.map(function (item) {
        return _react2.default.createElement(Item, {
          key: item.id
        }, _react2.default.createElement(_LabeledCheckbox2.default, {
          checked: value.indexOf(item.id) > -1,
          labelText: item.label,
          onChange: function onChange() {
            return _this2.onCheckBoxClick(item.id);
          }
        }));
      })));
    }
  }]);

  return MultiSelect;
}(_react.Component);

MultiSelect.propTypes = {
  className: _propTypes2.default.string,
  value: _propTypes2.default.arrayOf(_propTypes2.default.string),
  placeholder: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string
  }))
};
MultiSelect.defaultProps = {
  className: '',
  options: [],
  value: [],
  placeholder: ''
};
MultiSelect.contextTypes = {
  id: _propTypes2.default.string
};
exports.default = MultiSelect;
MultiSelect.__docgenInfo = [{
  'description': '',
  'displayName': 'MultiSelect',
  'methods': [{
    'name': 'onClickOutside',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'e',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'onCheckBoxClick',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'item',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'setWrapperRef',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'node',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'handleChange',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'e',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'filter',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'text',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'toggleItems',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }],
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'value': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'string'
        }
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '[]',
        'computed': false
      }
    },
    'placeholder': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'options': {
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'shape',
          'value': {
            'value': {
              'name': 'string',
              'required': false
            },
            'label': {
              'name': 'string',
              'required': false
            }
          }
        }
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '[]',
        'computed': false
      }
    }
  },
  'context': {
    'id': {
      'type': {
        'name': 'string'
      },
      'required': false
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/MultiSelect/index.js'] = {
    name: 'MultiSelect',
    docgenInfo: MultiSelect.__docgenInfo,
    path: 'src/MultiSelect/index.js'
  };
}